import {format} from 'date-fns';
import {ru} from 'date-fns/locale';

export function formatDate(date: string, formatStr = 'd MMMM y') {
    return format(new Date(date), formatStr, {locale: ru});
}

export function formatNumber(value: string | number) {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    return num.toLocaleString('ru-RU');
}

export function formatMoney(value: string | number) {
    // неразрывный пробел
    const nbsp = String.fromCharCode(160);
    return formatNumber(value) + `${nbsp}₽`;
}

export function capitalizeFirstLetter(value: string) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}

/** Удаляет все символы, кроме русских букв */
export function onlyRussianLetters(value: string) {
    return value.replace(/[^А-Яа-яЁё]/g, '');
}

export function formatUserName(value: string) {
    const capitalizeValue = capitalizeFirstLetter(value);
    return onlyRussianLetters(capitalizeValue);
}
